/**
 * Portada del dashboard: qué ha aportado Kombu en el periodo (007 US2, 009 US1)
 *
 * Título, frase de impacto y el camino del comensal.
 */

import type { DashboardEconomics, DashboardFilter, PeriodMetrics } from '@/types/dashboard';
import { JourneyStrip } from './JourneyStrip';
import { impactSentence } from './impactText';

interface ImpactSummaryProps {
  filter: DashboardFilter;
  current: PeriodMetrics;
  previous: PeriodMetrics;
  economics?: DashboardEconomics;
}

export function ImpactSummary({ filter, current, previous, economics }: ImpactSummaryProps) {
  return (
    <section className="space-y-4" aria-labelledby="impact-title">
      <div className="dash-rise space-y-2">
        <h2 id="impact-title" className="text-[16px] font-light text-[#1e1e1e]">
          Lo que Kombu ha hecho por tu restaurante
        </h2>
        <p className="max-w-3xl text-base font-light leading-relaxed text-[#1e1e1e]" data-testid="impact-sentence">
          {impactSentence(filter, current)}
        </p>
      </div>
      <div className="dash-rise" style={{ animationDelay: '0.1s' }}>
        <JourneyStrip filter={filter} current={current} previous={previous} economics={economics} />
      </div>
    </section>
  );
}
